var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNotifiationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3982 30.8342H21.0555C21.0555 32.0014 20.6197 33.1208 19.8438 33.9461C19.068 34.7714 18.0157 35.235 16.9185 35.235C15.8213 35.235 14.769 34.7714 13.9931 33.9461C13.2173 33.1208 12.7814 32.0014 12.7814 30.8342H2.43875C2.01452 30.8225 1.60494 30.6667 1.26996 30.3895C0.934984 30.1123 0.692183 29.7284 0.577084 29.2939C0.454992 28.8693 0.448482 28.4166 0.558311 27.9882C0.66814 27.5598 0.889813 27.1733 1.19765 26.8734C2.22218 26.0505 3.054 24.9868 3.62812 23.7653C4.20225 22.5439 4.50313 21.1978 4.50728 19.8321V13.231C4.50459 11.4954 4.82364 9.77629 5.44616 8.17198C6.06868 6.56768 6.98245 5.10969 8.1352 3.88143C9.28795 2.65316 10.6571 1.67874 12.1642 1.01389C13.6713 0.349048 15.2869 0.00683594 16.9185 0.00683594C18.55 0.00683594 20.1656 0.349048 21.6727 1.01389C23.1799 1.67874 24.549 2.65316 25.7017 3.88143C26.8545 5.10969 27.7682 6.56768 28.3908 8.17198C29.0133 9.77629 29.3323 11.4954 29.3296 13.231V19.8322C29.3338 21.1978 29.6347 22.544 30.2088 23.7654C30.7829 24.9869 31.6148 26.0506 32.6393 26.8735C32.9758 27.1505 33.2184 27.5366 33.3304 27.9733C33.4423 28.41 33.4176 28.8736 33.2599 29.294C33.1447 29.7285 32.9019 30.1124 32.567 30.3895C32.232 30.6667 31.8224 30.8225 31.3982 30.8342Z",
    fill: "#BAC0CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNotifiationIcon);
export default __webpack_public_path__ + "static/media/home-notifiation-icon.2293c989d849771f7ce4e5612f60d0b8.svg";
export { ForwardRef as ReactComponent };